var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEconomic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 2.51814L12.63 2.58814L9.72996 9.31814H6.87996C6.19996 9.31814 5.54996 9.45814 4.95996 9.70814L6.70996 5.52814L6.74996 5.42814L6.81996 5.26814C6.83996 5.20814 6.85996 5.14814 6.88996 5.09814C8.19996 2.06814 9.67996 1.37814 12.66 2.51814Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.05 9.51758C17.6 9.37758 17.12 9.31758 16.64 9.31758H9.72998L12.63 2.58758L12.66 2.51758C12.81 2.56758 12.95 2.63758 13.1 2.69758L15.31 3.62758C16.54 4.13758 17.4 4.66758 17.92 5.30758C18.02 5.42758 18.1 5.53758 18.17 5.66758C18.26 5.80758 18.33 5.94758 18.37 6.09758C18.41 6.18758 18.44 6.27758 18.46 6.35758C18.73 7.19758 18.57 8.22758 18.05 9.51758Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5217 14.1984V16.1484C21.5217 16.3484 21.5117 16.5484 21.5017 16.7484C21.3117 20.2384 19.3617 21.9984 15.6617 21.9984H7.86172C7.62172 21.9984 7.38172 21.9784 7.15172 21.9484C3.97172 21.7384 2.27172 20.0384 2.06172 16.8584C2.03172 16.6284 2.01172 16.3884 2.01172 16.1484V14.1984C2.01172 12.1884 3.23172 10.4584 4.97172 9.70836C5.57172 9.45836 6.21172 9.31836 6.89172 9.31836H16.6517C17.1417 9.31836 17.6217 9.38836 18.0617 9.51836C20.0517 10.1284 21.5217 11.9884 21.5217 14.1984Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3549 15.7969V16.6669C13.3549 17.404 12.6692 17.9997 11.8249 17.9997C10.9807 17.9997 10.2906 17.404 10.2906 16.6669V15.7969C10.2906 16.534 10.9764 17.0569 11.8249 17.0569C12.6692 17.0569 13.3549 16.5297 13.3549 15.7969Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3543 14.6176C13.3543 14.8319 13.2943 15.029 13.1915 15.2005C12.9386 15.6162 12.42 15.8776 11.82 15.8776C11.22 15.8776 10.7015 15.6119 10.4486 15.2005C10.3457 15.029 10.2858 14.8319 10.2858 14.6176C10.2858 14.2491 10.4572 13.9191 10.7315 13.6791C11.01 13.4348 11.3915 13.2891 11.8157 13.2891C12.24 13.2891 12.6215 13.4391 12.9 13.6791C13.1829 13.9148 13.3543 14.2491 13.3543 14.6176Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3549 14.618V15.7966C13.3549 16.5337 12.6692 17.0566 11.8249 17.0566C10.9807 17.0566 10.2906 16.5294 10.2906 15.7966V14.618C10.2906 13.8809 10.9764 13.2852 11.8249 13.2852C12.2492 13.2852 12.6307 13.4351 12.9092 13.6751C13.1835 13.9151 13.3549 14.2494 13.3549 14.618Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71 5.52734L4.96 9.70734C3.22 10.4573 2 12.1873 2 14.1973V11.2673C2 8.42734 4.02 6.05734 6.71 5.52734Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5186 11.2677V14.1977C21.5186 11.9977 20.0586 10.1277 18.0586 9.52766C18.5786 8.22766 18.7286 7.20766 18.4786 6.35766C18.4586 6.26766 18.4286 6.17766 18.3886 6.09766C20.2486 7.05766 21.5186 9.02766 21.5186 11.2677Z",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomic);
export default __webpack_public_path__ + "static/media/Economic.bbbba4a5da62423e5e8f1647968dba20.svg";
export { ForwardRef as ReactComponent };